import axios from 'axios';

export const event = {
  namespaced: true,
  state: {
    detail: {}
  },

  mutations: {
    setDetail(state, detail) {
      state.detail = detail
    },
    clear(state) {
      state.detail = {}
    }
  },

  actions: {
    async detail({ commit }) {
      const {
        VUE_APP_URL = "",
        VUE_APP_URL_LANG = "",
        VUE_APP_URL_TYPE = "",
        VUE_APP_URL_NAME = ""
      } = process.env;
      const url = `${VUE_APP_URL}${VUE_APP_URL_LANG}${VUE_APP_URL_TYPE}${VUE_APP_URL_NAME}`;
      await axios
        .get(`${url}event-detail.json`)
        .then(res => {
          commit('setDetail', res.data)
        })
    },
    clearStore({ commit }) {
      commit('clear')
    }
  }
}
